<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <rect
      x=".78"
      y="5.75"
      width="14.24"
      height="10.83"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <polygon
      points="23.35 16.59 15.03 16.59 15.03 8.98 19.68 8.98 23.35 12.06 23.35 16.59"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <circle cx="5.57" cy="16.53" r="2.18" fill="#fff" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5" />
    <circle
      cx="19.14"
      cy="16.53"
      r="2.18"
      fill="#fff"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
  </svg>
</template>

<script>
export default defineNuxtComponent({
  name: 'DeliveryIcon',
});
</script>
